/**
 * @format
 */

import { useState, useEffect } from 'react';
import { dashboardService } from '../services/dashboardService';
import { DailyPremiumData, WeeklyPremiumChartData } from '../types/weeklyPremium.types';
import { DashboardQueryParams } from '../types/dashboard.types';

export const useWeeklyPremium = (params?: DashboardQueryParams) => {
  const [chartData, setChartData] = useState<WeeklyPremiumChartData>({
    labels: [],
    currentWeekData: [],
    previousWeekData: [],
    currentWeekTotal: 0,
    previousWeekTotal: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data: DailyPremiumData[] = await dashboardService.getWeeklyPremium(params);

        // Extract data
        const labels = data.map((day) => day.dayOfWeek);
        const currentWeekData = data.map((day) => day.totalPremium);
        const previousWeekData = data.map((day) => day.previousTotalPremium);

        const currentWeekTotal = currentWeekData.reduce((acc, value) => acc + value, 0);
        const previousWeekTotal = previousWeekData.reduce((acc, value) => acc + value, 0);

        setChartData({
          labels,
          currentWeekData,
          previousWeekData,
          currentWeekTotal,
          previousWeekTotal,
        });
        setError(null);
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Failed to fetch weekly premium data');
        setError(error);
        console.error('Error fetching weekly premium data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [params]);

  return { chartData, loading, error };
};
